"use client";

import { useQuery } from "@tanstack/react-query";
import { getActiveExamDday } from "@/lib/server-actions/examDdayActions";

const ACTIVE_EXAM_DDAY_STALE_TIME_MS = 60_000;

/** 홈·모바일·마이페이지 D-day 위젯의 공용 활성 회차 조회. */
export function useExamDday() {
  const query = useQuery({
    queryKey: ["active-exam-dday"],
    queryFn: getActiveExamDday,
    staleTime: ACTIVE_EXAM_DDAY_STALE_TIME_MS,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return {
    data: query.data?.success ? query.data.data : null,
    isPending: query.isPending,
  };
}
